import styled from 'styled-components';

interface ContainerProps {
  isDarkMode: boolean;
}

export const Container = styled.div<ContainerProps>`
  margin-bottom: 24px;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled.div<ContainerProps & { color?: string }>`
  background-color: ${(props) =>
    props.isDarkMode ? '#262626' : '#ffffff'};
  border: 1px solid ${(props) =>
    props.isDarkMode ? '#434343' : '#d9d9d9'};
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: ${(props) =>
      props.isDarkMode
        ? '0 4px 12px rgba(0,0,0,0.45)'
        : '0 4px 12px rgba(0,0,0,0.15)'};
    transform: translateY(-2px);
  }
`;

export const StatLabel = styled.div<ContainerProps>`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => (props.isDarkMode ? '#a6a6a6' : '#666666')};
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const StatNumber = styled.div<{ color?: string }>`
  font-size: 32px;
  font-weight: 700;
  color: ${(props) => props.color || '#000000'};
  margin-bottom: 12px;
`;

export const StatHelpText = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${(props) => (props.isDarkMode ? '#8c8c8c' : '#999999')};

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: 6px;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const LoadingCard = styled(StatCard)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 140px;
`;

export const BreakdownContainer = styled.div<ContainerProps>`
  background-color: ${(props) =>
    props.isDarkMode ? '#262626' : '#ffffff'};
  border: 1px solid ${(props) =>
    props.isDarkMode ? '#434343' : '#d9d9d9'};
  border-radius: 8px;
  padding: 20px;
`;

export const BreakdownTitle = styled.h3<ContainerProps>`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => (props.isDarkMode ? '#ffffff' : '#000000')};
  margin: 0 0 20px 0;
`;

export const BreakdownGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const BreakdownItem = styled.div<ContainerProps>`
  background-color: ${(props) =>
    props.isDarkMode ? '#1f1f1f' : '#fafafa'};
  border: 1px solid ${(props) =>
    props.isDarkMode ? '#434343' : '#d9d9d9'};
  border-radius: 6px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) =>
      props.isDarkMode ? '#262626' : '#f5f5f5'};
    border-color: #1890ff;
  }
`;

export const BreakdownLabel = styled.span<ContainerProps>`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => (props.isDarkMode ? '#ffffff' : '#000000')};
`;

export const BreakdownCount = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #1890ff;
`;

export const EmptyState = styled.div<ContainerProps>`
  text-align: center;
  padding: 32px 20px;
  color: ${(props) => (props.isDarkMode ? '#8c8c8c' : '#999999')};
  font-size: 14px;
`;
